module.exports = __webpack_public_path__ + "img/13.c5c78128.jpg";